export class GetBillingHistoryBillDetails {
  static readonly type = '[BillingHistory] Get BillingHistory Bill Details';
  constructor(public queryParams: any) {}
}

export class GetSmeBillingHistoryBillDetails {
  static readonly type = '[BillingHistory] Get Sme BillingHistory Bill Details';
  constructor(public queryParams: any) {}
}
